




















































































































































































import { Component, Vue } from "vue-property-decorator";

import feather from "feather-icons";
import { NUBII_SIDEBAR_OPTIONS } from "@/resources/constants/sidebarMenu";
import { MIX_PANEL_CONSTANTS } from "@/resources/constants/mixpanel";
import { CHAT_TYPE } from "@/resources/constants/chat";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import { SpaceInterface } from "@/resources/interfaces/spaceInterfaces";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import InvitationFormComponent from "@/app/components/manageSpace/components/users/inviteUsers/invitationForm.component.vue";
import Loader from "@/resources/mixins/loader/loader";
import { SPACE_TYPE, USER_TYPE } from "@/resources/constants/space";
import { ClickOutsideDirective } from "@/helpers/directives/clickOutside.directive";
import ChangeSpaceSelectorComponent from "@/app/views/nubii/components/graphicClientOptions/components/changeSpaceSelector.component.vue";
import FloatMenuAnimation from "@/resources/mixins/animations/floatMenuAnimation";
import { PLAN } from "@/resources/constants/plan";
import Plans from "@/resources/mixins/plans/plans";
@Component({
  name: "sidebar-menu-component",
  components: {
    InvitationFormComponent,
    ChangeSpaceSelectorComponent,
  },
  directives: { ClickOutsideDirective },
})
export default class SidebarMenuComponent extends mixins(
  UserValidator,
  Loader,
  FloatMenuAnimation,
  Plans,
) {
  NUBII_SIDEBAR_OPTIONS = NUBII_SIDEBAR_OPTIONS;
  SPACE_TYPE = SPACE_TYPE;
  toolkitUrl = window.location.origin + process.env.VUE_APP_TOOLKIT_URL;
  spaceSpotify = process.env.VUE_APP_SPACE_SPOTIFY;
  feather = feather;
  city = false;
  openInvitation = false;
  favoriteSpaces = [];
  firstTime = true;
  showInvitation = false;
  showUtilities = false;
  showCalendar = false;
  showPoweUps = false;
  PLAN = PLAN;
  created(): void {
    this.city = localStorage.getItem("city") == "ON" ? false : true;
  }
  mounted(): void {
    if (!this.city) {
      this.activeMenu = NUBII_SIDEBAR_OPTIONS.LIST_SUPER_SPACES;
    }
    return feather.replace();
  }
  get activeMenu(): number {
    return this.$store.getters["SidebarStore/getActiveMenu"];
  }
  set activeMenu(e) {
    if (e != NUBII_SIDEBAR_OPTIONS.HAWKING_TOOL)
      this.$store.dispatch("SystemStore/setEducationToolModalAction", false);
    this.$store.dispatch("SidebarStore/setActiveMenuAction", e);
  }
  get spaceUser(): SpaceUserInterface {
    return this.$store.getters["UserStore/getSpaceUser"];
  }
  get space(): SpaceInterface {
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.isShowInvitation();
    this.isShow(space);
    this.isShowPowerUps(space);
    this.isShowCalendar(space);
    this.isShowUtilities(space);
    return space;
  }
  get powerUpsNotifications() {
    return this.$store.getters["SidebarStore/getPowerUpsNotifications"];
  }
  get showBadgeNewMessage(): boolean {
    const unSeenMessage = this.$store.getters["ChatStore/getUnSeenMessage"];
    const space = this.$store.getters["SpaceStore/getSpace"];
    return unSeenMessage.some((a) => {
      const parse = JSON.parse(a.payload.Metadata);
      if (
        space &&
        space.superSpace &&
        ((a.type === CHAT_TYPE.ONE_TO_ONE &&
          parse.superSpaceId == space.superSpace.id) ||
          (a.type === CHAT_TYPE.SPACE && parse.spaceId == space.id))
      )
        return true;
      return false;
    });
  }
  get user(): SpaceUserInterface {
    feather.replace();
    return this.$store.getters["UserStore/getSpaceUser"];
  }
  get getShowHawkingTool(): boolean {
    return this.$store.getters["HawkingsStore/getShowHawkingTool"];
  }
  get unSeeMessage() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    return this.$store.getters["ChatStore/getUnSeenMessage"].filter((a) => {
      const parse = JSON.parse(a.payload.Metadata);
      if (parse.superSpaceId == space.superSpace.id) return true;
      return false;
    });
  }
  openChatContainerHeight() {
    const chatMenuContainer = document.getElementById("chat-menu-container");
    const openChatsContainer = document.getElementById("open-chats-container");
    openChatsContainer.style.height =
      chatMenuContainer.clientHeight - 360 + "px";
  }
  openGeneralChat() {
    this.activeMenu = NUBII_SIDEBAR_OPTIONS.MESSAGE;
    this.$store.dispatch("ChatStore/setMessagesAction", []);
    this.$store.dispatch("ChatStore/setUserChatAction", null);
    this.$store.dispatch("SidebarStore/setOpenChatAction", false);
    if (this.unSeeMessage.length > 0) {
      if (this.unSeeMessage[0].id) {
        this.$store.dispatch("ChatStore/getOpenChatsAction", {
          spaceId: this.space.id,
          page: 1,
          callback: (response) => {
            const user = response.data.filter(
              (a) => a.superSpaceUser.id === this.unSeeMessage[0].id
            )[0];
            if (user) {
              this.$store.dispatch("ChatStore/setUserChatAction", {
                ...user.superSpaceUser,
              });
              this.$store.dispatch(
                "ChatStore/setChatTypeAction",
                this.unSeeMessage[0].type
              );
              this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
                id: user.superSpaceUser.id,
                type: this.unSeeMessage[0].type,
              });
            } else {
              let isDelete = false;
              const unSeeMessage =
                this.$store.getters["ChatStore/getUnSeenMessage"];
              unSeeMessage.forEach((unMessage) => {
                response.data.forEach((data) => {
                  if (unMessage.id == data.superSpaceUser.id) isDelete = true;
                });
                if (!isDelete) {
                  this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
                    id: unMessage.id,
                    type: CHAT_TYPE.ONE_TO_ONE,
                  });
                  this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
                    id: unMessage.id,
                    type: CHAT_TYPE.ROOM,
                  });
                  isDelete = false;
                }
              });
              this.openGeneralChat();
              return;
            }
            setTimeout(() => {
              this.$store.dispatch("SidebarStore/setOpenChatAction", true);
              this.$store.dispatch("ChatStore/setMinimizeChatAction", false);
            }, 50);
          },
          callbackError: (error) => {
            console.log(error);
          },
        });
      } else {
        this.$store.dispatch(
          "ChatStore/setChatTypeAction",
          this.unSeeMessage[0].type
        );
        this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
          type: this.unSeeMessage[0].type,
        });
        setTimeout(() => {
          this.$store.dispatch("SidebarStore/setOpenChatAction", true);
          this.$store.dispatch("ChatStore/setMinimizeChatAction", false);
        }, 50);
      }
    } else {
      if (this.activeOptionPlan(PLAN.GENERAL_CHAT) && this.isGeneralChatActive) {
        this.$store.dispatch("ChatStore/setChatTypeAction", CHAT_TYPE.SPACE);
        this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
          type: CHAT_TYPE.SPACE,
        });
      } else {
        this.$store.dispatch("ChatStore/setChatTypeAction", "");
      }
      setTimeout(() => {
        this.$store.dispatch("SidebarStore/setOpenChatAction", true);
        this.$store.dispatch("ChatStore/setMinimizeChatAction", false);
      }, 50);
    }
  }
  get isGeneralChatActive() {
    return this.$store.getters["SpaceStore/getSpace"].isChatActive;
  }
  setActiveMenu(e: number): void {
    const element = document.getElementsByClassName("open-menu-container")[0];
    if (element) element["style"].left = "-23rem";
    setTimeout(() => {
      this.$store.dispatch("SidebarStore/setActiveMenuAction", e);
    }, 500);
  }
  showOpenChangeSpaceSelector() {
    if (
      this.$store.getters["FloatMenuStore/getOpenChangeSpaceSelector"] ||
      this.firstTime
    ) {
      // this.getSpaceFavourites();
      this.firstTime = false;
    }
    return this.$store.getters["FloatMenuStore/getOpenChangeSpaceSelector"];
  }
  async exitNubii(): Promise<void> {
    const favouriteSpaces =
      this.$store.getters["SpaceStore/getFavouriteSpaces"];
    if (favouriteSpaces?.length === 0) {
      this.changeSpace();
    } else if (
      !this.$store.getters["FloatMenuStore/getOpenChangeSpaceSelector"]
    ) {
      setTimeout(() => {
        this.$store.dispatch(
          "FloatMenuStore/setOpenChangeSpaceSelectorAction",
          true
        );
      }, 50);
      setTimeout(() => {
        this.openChangeSpaceSelector();
      }, 200);
    }
  }
  addFriend(): void {
    this.$store.dispatch("FloatMenuStore/setOpenHelpBotAction", true);
  }
  createdSpace(): void {
    window.open("https://nubi.city/get-started.html", "_blank").focus();
  }
  openHawkingsTool() {
    if (!this.$store.getters["SystemStore/getShowEducationToolModal"]) {
      this.$store.dispatch("SystemStore/setEducationToolModalAction", true);
      this.activeMenu = NUBII_SIDEBAR_OPTIONS.HAWKING_TOOL;
    } else {
      this.$store.dispatch("SystemStore/setEducationToolModalAction", false);
      this.setActiveMenu(-1);
    }
  }
  openModalInvitation() {
    this.$store.dispatch("SpaceStore/setSelectedSpaceCustomizeAction", null);
    this.$store.dispatch("SystemStore/setEducationToolModalAction", false);
    this.openInvitation = true;
  }
  openToolKits() {
    if (!this.activeOptionPlan(PLAN.POWER_UPS)) {
      return
    }
    this.$store.dispatch(
      "SystemStore/setWonderPointUrlAction",
      this.toolkitUrl
    );
    const space = this.$store.getters["SpaceStore/getSpace"];
    const user = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("SystemStore/setOpenWonderPointModalAction", true);
    this.$mixpanel.track(MIX_PANEL_CONSTANTS.POWER_UPS, {
      distinct_id: this.spaceUser.superSpaceUser.user.id,
      "Space ID": space.id || null,
      "Space Name": space.name || null,
      "Space Type": space.type || null,
      "Scenario Name": space.scenario.scenarioType.name || null,
      "Super Space Name": space.superSpace.name || null,
      "Super Space ID": space.superSpace.id || null,
    });
    //LOAD POWER_UP NOTIFICATIONS
    if (process.env.VUE_APP_ENVIRONMENT === "PRO") {
      this.$store.dispatch("SidebarStore/getPowerUpsNotificationsAction", {
        userId: user.superSpaceUser.user.id,
        spaceId: space.id,
      });
    }
    /////////////////////////////
  }
  openCalendarModal() {
    if (!this.activeOptionPlan(PLAN.AGENDA)) return;
    this.$store.dispatch("FloatMenuStore/setOpenCalendarModalAction", true);
  }
  closeReason(): void {
    setTimeout(() => {
      this.closeChangeSpacenSelector();
    }, 50);
    setTimeout(() => {
      this.$store.dispatch(
        "FloatMenuStore/setOpenChangeSpaceSelectorAction",
        false
      );
    }, 200);
  }
  async getSpaceFavourites() {
    this.activeMenu = NUBII_SIDEBAR_OPTIONS.CHANGE_SPACE;
    this.$store.dispatch("SpaceStore/getFavouriteSpacesAction", {
      page: 1,
      callback: (response) => {
        this.exitNubii();
      },
      callbackError: (error) => {},
    });
  }
  async changeSpace(): Promise<void> {
    this.startLoader(this.$store);
    const space = this.$store.getters["SpaceStore/getSpace"];

    await this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
    await this.$store.dispatch("SpaceStore/setLastPageSpacesAction", 2);
    await this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
      id: space.superSpace.id,
      callback: (response) => {
        this.stopLoader(this.$store);
        this.$store.dispatch("SystemStore/setOpenChangeSpaceModalAction", true);
      },
      callbackError: (error) => {
        // do nothing
      },
    });
  }
  isShow(space: any) {
    if (!space) return;
    if (space.superSpace && space.superSpace.company == "HAWKINGS") {
      let localUser = this.$store.getters["UserStore/getSpaceUser"];
      if (!localUser) return;
      if (
        localUser.hawkingsType == USER_TYPE.TEACHER ||
        localUser.hawkingsType == USER_TYPE.STAFF ||
        this.isAdmin() ||
        this.isSuperSpaceOwner()
      ) {
        this.$store.dispatch("HawkingsStore/setShowHawkingToolAction", true);
      }
    }
  }
  isShowInvitation() {
    if (!this.user) return;
    if (this.isAdmin() || this.canInvite()) this.showInvitation = true;
  }
  isShowUtilities(space: any) {
    if (!space) return;
    if (space && space.type === SPACE_TYPE.OFFICE_TYPE)
      this.showUtilities = true;
  }
  isShowPowerUps(space: any) {
    if (!space) return;
    if (
      space.type === SPACE_TYPE.OFFICE_TYPE &&
      space.superSpace &&
      (space.superSpace.company === "NUBI" || space.superSpace.company === "SF")
    )
      this.showPoweUps = true;
  }
  isShowCalendar(space: any) {
    if (!space) return;
    if (space && space.type === SPACE_TYPE.EVENT_TYPE) this.showCalendar = true;
  }
}
